import Plausible from "plausible-tracker";

const plausible = Plausible({
  trackLocalhost: false,
  domain: "seamworks.coats-digital.com",
  apiHost: "https://analytics.coats-digital.com"
});

export default plausible;
